// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LNgE","col":"styles_col__3kM2c"};